<template>
  <div style="height: 100%">
    <!--If Has FUS: Add a FUS box -->
    <record-automated-follow-up-card
      v-if="isInFollowUp"
      :current-follow-up-id="record.current_follow_up_id"
      style="box-shadow: none"
    ></record-automated-follow-up-card>

    <div v-if="record" class="pb-100">
      <keep-alive>
        <component
          v-bind:is="leadBoxComponent"
          v-bind="{record: record, status: status}"
        ></component>
      </keep-alive>
    </div>
    <div v-else class="flex flex-vertical-center flex-centered" style="height: 100%">
      <div class="no_primary_lead">
        <h5 class="no_primary_lead--heading">There is no primary lead for the contact</h5>
        <p class="no_primary_lead--text">Add a primary lead to the contact in order to see lead info here</p>
      </div>
    </div>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import LeadBoxActive from "./LeadBoxActive";
import LeadBoxCompleted from "./LeadBoxCompleted";
import LeadBoxContacting from "./LeadBoxContacting";
import LeadBoxDead from "./LeadBoxDead";
import LeadBoxFollowUp from "./LeadBoxFollowUp";
import LeadBoxNonLead from "./LeadBoxNonLead";

export default {
  name: "LeadBox",
  components: {
    LeadBoxActive,
    LeadBoxCompleted,
    LeadBoxContacting,
    LeadBoxDead,
    LeadBoxFollowUp,
    LeadBoxNonLead,
  },
  props: {
    type: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      leadBoxComponent: null,
    };
  },
  computed: {
    isNewLead() {
      return this.type === ENUMS.InboxTypeEnum.NewLead.value;
    },
    isInboundComm() {
      return this.type === ENUMS.InboxTypeEnum.InboundComm.value;
    },
    record() {
      if (this.isNewLead) {
        return {
          ...this.$store.getters["activeInboxLeadItem/record"],
          property: this.$store.getters["activeInboxLeadItem/property"],
          notes: this.$store.getters["activeInboxLeadItem/notes"]
        };
      }
      if (this.isInboundComm) {
        return {
          ...this.$store.getters["activeInboxInboundCommItem/record"],
          property: this.$store.getters["activeInboxInboundCommItem/property"],
          notes: this.$store.getters["activeInboxInboundCommItem/notes"],
        }
      }
    },
    status() {
      if (!this.record.current_status_id) return {};

      return this.$store.getters["pipeline/getStatusById"](this.record.current_status_id);
    },
    isInFollowUp() {
      return this.record && this.record.current_follow_up_id;
    }
  },
  created() {
    // Contacting
    if (this.status && this.status.state === ENUMS.StatusStateEnum.Contacting.value) {
      this.leadBoxComponent = "LeadBoxContacting";
    }

    // Active
    if (this.status && this.status.state === ENUMS.StatusStateEnum.Active.value) {
      this.leadBoxComponent = "LeadBoxActive";
    }

    // Follow Up
    if (this.status && this.status.state === ENUMS.StatusStateEnum.FollowUp.value) {
      this.leadBoxComponent = "LeadBoxFollowUp";
    }

    // Completed
    if (this.status && this.status.state === ENUMS.StatusStateEnum.Completed.value) {
      this.leadBoxComponent = "LeadBoxCompleted";
    }

    // Dead
    if (this.status && this.status.state === ENUMS.StatusStateEnum.Dead.value) {
      this.leadBoxComponent = "LeadBoxDead";
    }

    // Non Lead
    if (this.status && this.status.state === ENUMS.StatusStateEnum.NonLead.value) {
      this.leadBoxComponent = "LeadBoxNonLead";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.no_primary_lead {
  text-align: center;

  &--heading {
    margin: -2rem 0 10px;
    font-size: 1.25rem;
    font-style: italic;
    color: $text-muted;
  }

  &--text {
    width: 80%;
    margin: 0 auto;
    font-style: italic;
    color: $text-muted;
    line-height: 1.3;
  }
}

.note {
  font-size: 0.8rem;
  color: $text-light;
  line-height: 1.3;
}
</style>
